import { formMarketoSubmitPipe } from "../submit";
import { formDefaultSubmitPipe } from "../submit";
import { phoneNumberMasking } from "./phoneMasking";
import {
  setOnChangeValidation,
  setLocationDropDownOnChange,
} from "./interactions";
import { setReferenceCode } from "./referenceCode";
import { changeUncontrolledSubmitButtonDuplicateForm } from "./util";

//  initialize the form
export const formInitialization = ($form) => {
  const $inputElements = $form.find("input, select, textarea");
  changeUncontrolledSubmitButtonDuplicateForm($form);

  //  set up interactions for specific fields
  $inputElements.each((_, el) => {
    setOnChangeValidation($(el));

    if (el.name === "Phone") {
      phoneNumberMasking($form);
    }

    if (el.name === "Reference_Code__c") {
      setReferenceCode($(el), $form);
    }

    if (el.name === "location_id") {
      setLocationDropDownOnChange($(el), $form);
    }
  });

  const isMarketoForm = $form.hasClass("marketo-form");

  if (isMarketoForm) {
    $form.submit(formMarketoSubmitPipe($form));
  } else {
    $form.submit(formDefaultSubmitPipe($form));
  }
};
